import { Checkboxes } from 'nhsuk-react-components';

const FilterByCheckbox = ({
    submissionSummary,
    selectedStaffGroup,
    setSelectedStaffGroup,
    staffRoleOptions,
    setStaffRoleOptions,
    selectedPCNStaffGroup,
    setSelectedPCNStaffGroup,
    PCNstaffRoleOptions,
    setPCNStaffRoleOptions
}) => {
    // Get collection ID directly on render
    const collectionID = sessionStorage.getItem('collectionID');
    const isGpCollection = collectionID === 'NHS Workforce GP Practice Staff Details';

    // Extract GP and PCN questions/options directly from submissionSummary
    const gpStaffGroupQuestion = submissionSummary.find(q => q.id === 'home-page-staff-group-gp');
    const gpStaffGroups = gpStaffGroupQuestion?.options || [];

    const pcnStaffGroupQuestion = submissionSummary.find(q => q.id === 'home-page-staff-group-pcn');
    const pcnStaffGroups = pcnStaffGroupQuestion?.options || [];

    const handleGpGroupChange = groupKey => {
        const newGroup = selectedStaffGroup === groupKey ? null : groupKey;
        setSelectedStaffGroup(newGroup);

        const selectedGroup = gpStaffGroups.find(g => g.key === newGroup);
        const staffRoleQuestion = selectedGroup?.questions?.find(q => q.id.includes('staff-role'));
        setStaffRoleOptions(staffRoleQuestion?.options || []);
    };

    const handlePcnGroupChange = groupKey => {
        const newGroup = selectedPCNStaffGroup === groupKey ? null : groupKey;
        setSelectedPCNStaffGroup(newGroup);

        const selectedGroup = pcnStaffGroups.find(g => g.key === newGroup);
        const staffRoleQuestion = selectedGroup?.questions?.find(q => q.id.includes('staff-role'));
        setPCNStaffRoleOptions(staffRoleQuestion?.options || []);
    };

    return (
        <form>
            {/* Other filters that are not staff group */}
            {submissionSummary
                .filter(
                    q =>
                        (q.type === 'radio' || q.type === 'select') &&
                        q.id !== 'home-page-staff-group-gp' &&
                        q.id !== 'home-page-staff-group-pcn'
                )
                .map(question => (
                    <Checkboxes
                        name={question.id}
                        id={question.id}
                        label={question.display}
                        key={question.id}
                    >
                        {question.options.map((option, index) => (
                            <Checkboxes.Box key={index} value={option.key} onChange={() => {}}>
                                {option.value}
                            </Checkboxes.Box>
                        ))}
                    </Checkboxes>
                ))}

            {/* GP Staff Group Filters */}
            {isGpCollection && (
                <>
                    <Checkboxes name="home-page-staff-group-gp" label="Practice Staff Group">
                        {gpStaffGroups.map(group => (
                            <Checkboxes.Box
                                key={group.key}
                                name="home-page-staff-group-gp"
                                value={group.key}
                                checked={selectedStaffGroup === group.key}
                                onChange={() => handleGpGroupChange(group.key)}
                            >
                                {group.value}
                            </Checkboxes.Box>
                        ))}
                    </Checkboxes>

                    {selectedStaffGroup && (
                        <Checkboxes label="Staff Role">
                            {staffRoleOptions.length === 0 ? (
                                <p>Please select a staff group first.</p>
                            ) : (
                                staffRoleOptions.map(option => (
                                    <Checkboxes.Box
                                        key={option.key}
                                        name="staff-role"
                                        value={option.key}
                                        onChange={() => {}}
                                    >
                                        {option.value}
                                    </Checkboxes.Box>
                                ))
                            )}
                        </Checkboxes>
                    )}
                </>
            )}

            {/* PCN Staff Group Filters */}
            {!isGpCollection && (
                <>
                    <Checkboxes name="home-page-staff-group-pcn" label="PCN Staff Group">
                        {pcnStaffGroups.map(group => (
                            <Checkboxes.Box
                                key={group.key}
                                name="home-page-staff-group-pcn"
                                value={group.key}
                                checked={selectedPCNStaffGroup === group.key}
                                onChange={() => handlePcnGroupChange(group.key)}
                            >
                                {group.value}
                            </Checkboxes.Box>
                        ))}
                    </Checkboxes>

                    {selectedPCNStaffGroup && (
                        <Checkboxes label="Staff Role">
                            {PCNstaffRoleOptions.length === 0 ? (
                                <p>Please select a PCN staff group first.</p>
                            ) : (
                                PCNstaffRoleOptions.map(option => (
                                    <Checkboxes.Box
                                        key={option.key}
                                        name="staff-role"
                                        value={option.key}
                                        onChange={() => {}}
                                    >
                                        {option.value}
                                    </Checkboxes.Box>
                                ))
                            )}
                        </Checkboxes>
                    )}
                </>
            )}
        </form>
    );
};

export default FilterByCheckbox;
